import { useEffect, useState } from 'react'
import { Modal, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

import { TitleH1 } from '../../../../../../../../Components/CustomUi/titleH1'
import { TitleH2 } from '../../../../../../../../Components/CustomUi/titleH2'
import { ContainerVisuCSV } from './styled'
import type { AmostraData } from '../../../../meta/parseCsv'

const { Text } = Typography

interface Props {
  isOpen: boolean
  onClose: () => void
  dataCSV: AmostraData[]
}

/** Modal de pré-visualização do CSV de resultado da análise (por amostra). */
const CsvVisualizationModal: React.FC<Props> = ({ isOpen, onClose, dataCSV }) => {
  const [selectedId, setSelectedId] = useState<string>('')

  const selectedSample = dataCSV.find((item) => item.id === selectedId) || dataCSV[0]

  const DataItem = ({ label, value }: { label: string; value: string | number }) => (
    <div style={{ marginBottom: 12 }}>
      <Text
        type='secondary'
        style={{ display: 'block', fontSize: 11, textTransform: 'uppercase', fontWeight: 600 }}
      >
        {label}
      </Text>
      <Text strong style={{ fontSize: 15 }}>
        {value}
      </Text>
    </div>
  )

  useEffect(() => {
    setSelectedId(dataCSV[0]?.id)
  }, [isOpen])

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      width={'70%'}
      footer={null}
      centered
      bodyStyle={{ padding: 0, height: '70vh', overflow: 'hidden' }}
      closeIcon={false}
    >
      <ContainerVisuCSV>
        <div className='header'>
          <TitleH1>Visualizar análise</TitleH1>
          <FontAwesomeIcon icon={faXmark} fontSize={18} style={{ cursor: 'pointer' }} onClick={onClose} />
        </div>

        <div className='modal__infos'>
          <div>
            <label>Nome proprietário</label>
            <p>{selectedSample?.nome}</p>
          </div>
          <div>
            <label>Endereço</label>
            <p>{selectedSample?.endereco}</p>
          </div>
          <div>
            <label>Propriedade</label>
            <p>{selectedSample?.propriedade}</p>
          </div>
        </div>

        <div className='body__conteudo'>
          <div className='campo__amostra'>
            <label className='title'>Análises</label>
            <div style={{ overflowY: 'auto' }}>
              {dataCSV?.map((item) => {
                return (
                  <div
                    key={item.id}
                    onClick={() => setSelectedId(item.id)}
                    className='selecionar__amostra'
                    data-active={item.id === selectedId}
                  >
                    <label>#{item.numero}</label>
                    <div>
                      <div className='circle__selecionada' data-active={item.id === selectedId}></div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          <div className='detalhes__amostra '>
            <div className='header__detalhe'>
              <TitleH2 style={{ fontSize: '13px' }}>Detalhes Completos da Amostra</TitleH2>
            </div>
            <div className='conteudo__analises'>
              <DataItem label='NÚMERO' value={selectedSample?.numero} />
              <DataItem label='MG' value={selectedSample?.mg} />
              <DataItem label='CA/K' value={selectedSample?.ca_k} />
              <DataItem label='BORO' value={selectedSample?.boro} />

              <DataItem label='ALUMÍNIO' value={selectedSample?.aluminio} />
              <DataItem label='MG/K' value={selectedSample?.mg_k} />
              <DataItem label='P' value={selectedSample?.p} />

              <DataItem label='H+AL' value={selectedSample?.hal} />
              <DataItem label='FERRO' value={selectedSample?.ferro} />
              <DataItem label='P REM' value={selectedSample?.p_rem} />

              <DataItem label='SB' value={selectedSample?.sb} />
              <DataItem label='MANGANÊS' value={selectedSample?.manganes} />
              <DataItem label='PH EM CACL2' value={selectedSample?.ph_cacl2} />

              <DataItem label='GLEBA' value={selectedSample?.gleba} />
              <DataItem label='CTC' value={selectedSample?.ctc} />
              <DataItem label='BASES V%' value={selectedSample?.bases_v} />
              <DataItem label='COBRE' value={selectedSample?.cobre} />

              <DataItem label='M.O.' value={selectedSample?.mo} />
              <DataItem label='AL M%' value={selectedSample?.al_pct} />
              <DataItem label='%CA' value={selectedSample?.percent_ca} />
              <DataItem label='ZINCO' value={selectedSample?.zinco} />

              <DataItem label='P REM' value={selectedSample?.p_rem} />
              <DataItem label='%MG' value={selectedSample?.mg_pct} />
              <DataItem label='%K' value={selectedSample?.percent_k} />
              <DataItem label='TEOR DE SILTE' value={selectedSample?.teor_silte} />
            </div>
          </div>
        </div>
      </ContainerVisuCSV>
    </Modal>
  )
}

export default CsvVisualizationModal
